export default __webpack_public_path__ + "media/zurb/img/services/design-insight/design-insight-img3-c5075378cca017cd2ad507082c2e0cfa.png";